// Include React Modules
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Router, Switch, BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";

/**************** INCLUDE STYLES ******************/

// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.scss';

import 'react-toastify/dist/ReactToastify.min.css';

import './assets/css/step.css';
import "./assets/css/app.css";
import './assets/css/index.css'
// @\import '~antd/dist/antd.css';
/************** END INCLUDE STYLES *****************/

// Include Store consisting of Saga (Middlewares) and Reducer (States)
import store from "./store";

// Include the Root Routes configurations loader
import InitialRoute from './routes/initialRoute.js'
import config from './config_sample';
import { history } from "./store";
import Amplify from 'aws-amplify';
Amplify.configure({
	Auth: {
		// mandatorySignIn: true,
		region: config.cognito.REGION,
		userPoolId: config.cognito.USER_POOL_ID,
		identityPoolId: config.cognito.IDENTITY_POOL_ID,
		userPoolWebClientId: config.cognito.APP_CLIENT_ID
	},
	API: {
		endpoints: [
			{
				name: 'vopsapi',
				endpoint: config.apiGateway.URL,
				region: config.apiGateway.REGION
			}
		]
	}
});


ReactDOM.render((
	<Provider store={store}>
		<Router history={history}>
			{/* <BrowserRouter> */}
			<InitialRoute />
			{/* </BrowserRouter> */}
		</Router>
	</Provider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js